import { useReducer, useEffect } from 'react'
import { Routes } from 'app/services/routeService/routeService'

export const ActionType = {
  OPEN_CHANGE_PLAN_DIALOG: 'OPEN_CHANGE_PLAN_DIALOG',
  OPEN_SUMMARY_DIALOG: 'OPEN_SUMMARY_DIALOG',
  CLOSE_CHANGE_PLAN_DIALOG: 'CLOSE_CHANGE_PLAN_DIALOG',
  CLOSE_SUMMARY_DIALOG: 'CLOSE_SUMMARY_DIALOG',
  CHANGE_OPENING_DIALOG: 'CHANGE_OPENING_DIALOG',
}

const initialState = {
  isOpenChangePlanDialog: false,
  changePlanFormData: {},
  isOpenSummaryDialog: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.OPEN_CHANGE_PLAN_DIALOG:
      return {
        ...state,
        isOpenChangePlanDialog: true,
      }
    case ActionType.CLOSE_CHANGE_PLAN_DIALOG:
      return {
        ...state,
        isOpenChangePlanDialog: false,
      }
    case ActionType.OPEN_SUMMARY_DIALOG:
      return {
        ...state,
        changePlanFormData: action.payload,
        isOpenSummaryDialog: true,
      }
    case ActionType.CLOSE_SUMMARY_DIALOG:
      return {
        ...state,
        isOpenSummaryDialog: false,
      }
    default:
      return state
  }
}

export default function useChangePlan(location, history, enableChangePlan) {
  const isChangePlanPath = location.pathname === Routes.billingchangePlan()
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    isOpenChangePlanDialog: isChangePlanPath && enableChangePlan,
  })

  useEffect(() => {
    if (isChangePlanPath && enableChangePlan)
      dispatch({ type: ActionType.OPEN_CHANGE_PLAN_DIALOG })
  }, [isChangePlanPath, dispatch, enableChangePlan])

  useEffect(() => {
    history.push(
      state.isOpenChangePlanDialog
        ? Routes.billingchangePlan()
        : Routes.billingOverview(),
    )
  }, [state.isOpenChangePlanDialog, history])
  return [state, dispatch]
}
